import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import axios from "axios";
import Sidebar from "./layout/Sidebar";
import AddCourse from "./add/AddCourse"

export default function CoursePanel() {

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterText, setFilterText] = useState("");
  const [addform, setaddform] = useState(false);

  const columns = [
    { name: "ID", selector: row => row.id, sortable: true },
    { name: "Name", selector: row => row.name || "N/A", sortable: true },
    { name: "Description", selector: row => row.description || "N/A", sortable: true },

    // ✅ Actions Column
    // {
    //   name: "Actions",
    //   cell: row => (
    //     <div className="d-flex">
    //       {/* <button
    //         className="btn btn-sm btn-danger"
    //         onClick={() => handleDelete(row.id)}
    //       >
    //         <i className="bi bi-trash"></i>
    //       </button> */}
    //     </div>
    //   ),
    // },
  ];

  function getData(){
      axios.get(`${process.env.REACT_APP_BASE_URL}api/course/open/getCourses`)
      .then(result=>setData(result.data))
      .catch(err=>console.log(err))
      .finally(setLoading(false));    
  }
  useEffect(()=>getData(),[]);

  const filteredData = filterText
    ? data.filter(item =>
        (item.fullname || "").toLowerCase().includes(filterText.toLowerCase()) ||
        (item.email || "").toLowerCase().includes(filterText.toLowerCase()) ||
        (item.mobile || "").toLowerCase().includes(filterText.toLowerCase()) 
      )
    : data;

    return (<>
      <div className="container-fluid">
          <div className="row">
             <div className="col-12 col-md-3 col-lg-2 sidebar-container">
                 <Sidebar></Sidebar>
             </div>
             <div className="col-12 col-md-9 col-lg-10 main-container">
                 <div className="container mt-4">
                  <h2 className="text-center mb-3">Course List</h2>
                  <hr />
                  {/* Action Buttons + Search Bar */}
                  <div className="d-flex justify-content-between align-items-center mb-0">
                  <AddCourse></AddCourse>
                  </div>
                  {/* Data Table */}
                  <div className="card shadow" style={{overflow:"auto"}}>
                    <div className="card-body">
                      <DataTable
                        columns={columns}
                        data={filteredData}
                        progressPending={loading}
                        pagination
                        highlightOnHover
                        striped
                      />
                    </div>
                  </div>
                </div>
             </div>
          </div>
      </div> 
    </>);
}